import React from "react";
import s from './footer.module.scss';
import { PAYMENT_TARIFF } from "../../../types";
import locales from '../../../content.json';

export const Footer = ({ tariff }: { tariff?: string }) => {

  return (
    <div className={`${s.footer} ${(tariff === PAYMENT_TARIFF.V5 || tariff === PAYMENT_TARIFF.V7 || tariff === PAYMENT_TARIFF.V9 || tariff === PAYMENT_TARIFF.V11 || tariff === PAYMENT_TARIFF.V13 || tariff === PAYMENT_TARIFF.V15 || tariff === PAYMENT_TARIFF.V18 || tariff === PAYMENT_TARIFF.V20 || tariff === PAYMENT_TARIFF.V22 || tariff === PAYMENT_TARIFF.V24 || tariff === PAYMENT_TARIFF.V26 || tariff === PAYMENT_TARIFF.V28 || tariff === 'withSecondStyle') ? s.tariffV5 : ''}`}>
      <p>
        Star Focus, Inc.
      </p>
      <p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_29}}>
      </p>
    </div>
  );
};